/**
 * @param {HTMLElement} hero
 * @returns {HTMLElement | null}
 */
function getHeroTextureElement(hero) {
  const texture = hero.querySelector('.hero__bottom-texture');
  return texture instanceof HTMLElement ? texture : null;
}

/**
 * @param {Element | null} section
 * @returns {HTMLElement | null}
 */
function findTransitionFillCarrier(section) {
  if (!(section instanceof HTMLElement)) return null;

  const candidates = [
    ...section.querySelectorAll('.section-background[class*="color-"], .section[class*="color-"], [class*="color-"]'),
  ];

  if (section.className.includes('color-')) {
    candidates.unshift(section);
  }

  for (const candidate of candidates) {
    if (!(candidate instanceof HTMLElement)) continue;

    const fill = getComputedStyle(candidate).getPropertyValue('--section-transition-fill').trim();
    if (fill) return candidate;
  }

  return null;
}

/**
 * @param {HTMLElement} hero
 * @returns {HTMLElement | null}
 */
function findNextSectionCarrier(hero) {
  const heroSection = hero.closest('.shopify-section');
  let nextSection = heroSection?.nextElementSibling;

  while (nextSection instanceof HTMLElement) {
    const carrier = findTransitionFillCarrier(nextSection);
    if (carrier) return carrier;
    nextSection = nextSection.nextElementSibling;
  }

  return null;
}

/**
 * @param {HTMLElement} hero
 */
export function updateHeroBottomTexture(hero) {
  if (hero.dataset.heroBottomTextureEnabled !== 'true') return;

  const texture = getHeroTextureElement(hero);
  if (!texture) return;

  const carrier = findNextSectionCarrier(hero);
  const transitionFill = carrier ? getComputedStyle(carrier).getPropertyValue('--section-transition-fill').trim() : '';
  const transitionBackground = carrier
    ? getComputedStyle(carrier).getPropertyValue('--section-transition-background').trim()
    : '';

  if (!transitionFill) {
    hero.style.removeProperty('--hero-bottom-texture-color');
    hero.style.removeProperty('--hero-bottom-texture-background');
    texture.hidden = true;
    return;
  }

  hero.style.setProperty('--hero-bottom-texture-color', transitionFill);
  hero.style.setProperty('--hero-bottom-texture-background', transitionBackground || transitionFill);
  texture.hidden = false;
}

/**
 * @param {ParentNode} [root]
 */
export function updateAllHeroBottomTextures(root = document) {
  const heroes = root.querySelectorAll('.hero[data-hero-bottom-texture-enabled="true"]');

  heroes.forEach((hero) => {
    if (hero instanceof HTMLElement) updateHeroBottomTexture(hero);
  });
}

function initHeroTextureTransitions() {
  updateAllHeroBottomTextures();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroTextureTransitions, { once: true });
} else {
  initHeroTextureTransitions();
}
